var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardPurchaseReturnImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 27.5V22.5C5 13.75 10 10 17.5 10H42.5C50 10 55 13.75 55 22.5V37.5C55 46.25 50 50 42.5 50H30",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36.25C33.4518 36.25 36.25 33.4518 36.25 30C36.25 26.5482 33.4518 23.75 30 23.75C26.5482 23.75 23.75 26.5482 23.75 30C23.75 33.4518 26.5482 36.25 30 36.25Z",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 23.75V36.25",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 38.75H18.3501C19.9501 38.75 21.25 40.0499 21.25 41.6499V44.85",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04993 35.7001L5 38.75L8.04993 41.7999",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 51.9501H7.89993C6.29993 51.9501 5 50.65 5 49.05V45.8501",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2031 55.0008L21.2531 51.9508L18.2031 48.9008",
    stroke: "#6366F1",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardPurchaseReturnImg);
export default __webpack_public_path__ + "static/media/card-purchase-return-img.6b740d04b550b6568a535e74c472817e.svg";
export { ForwardRef as ReactComponent };